import * as yup from "yup";
import i18n from "../../../../i18n";

const requiredMessage = () => i18n.t("validation.required", {ns: "common"});
const min6LengthsMessage = () => i18n.t("validation.minLengths", {ns: "common", min: 6});
const max255LengthsMessage = () => i18n.t("validation.maxLength", {ns: "common", max: 255});
const phoneFormatMessage = () => i18n.t("validation.phoneFormat", {ns: "common"});
const emailFormatMessage = () => i18n.t("validation.emailFormat", {ns: "common"});
const tcknFormatMessage = () => i18n.t("validation.tcknFormat", {ns: "common"});

export const createCourierCandidateValidation = yup.object().shape({
    fullname: yup
        .string()
        .trim()
        .min(6, min6LengthsMessage)
        .max(255, max255LengthsMessage)
        .matches(/^\S+(\s+\S+)+$/, "İsim ve soyisim birlikte girilmelidir.")
        .required(requiredMessage),
    tckn: yup
        .string()
        .matches(/^[1-9]{1}[0-9]{9}[2,4,6,8,0]{1}$/, tcknFormatMessage)
        .required(requiredMessage),
    cellPhone: yup
        .string()
        .matches(/^0(\(([0-9]{3}\)-[0-9]{3}-[0-9]{4}))|([0-9]{10}$)/, phoneFormatMessage)
        .required(requiredMessage),
    email: yup
        .string()
        .email(emailFormatMessage)
        .required(requiredMessage),
    gender: yup
        .string()
        .oneOf(["male", "female"], requiredMessage)
        .required(requiredMessage),
    bloodGroup: yup.string().required(requiredMessage),
    birthDate: yup.date().required(requiredMessage),
    motorTypeId: yup.string().required(requiredMessage),
    drivingLicenseIds: yup
        .array()
        .of(yup.string())
        .min(1, requiredMessage)
        .required(requiredMessage),
    preferredCityId: yup.string().required(requiredMessage),
    preferredDistrictIds: yup
        .array()
        .of(yup.string())
        .min(1, requiredMessage)
        .required(requiredMessage),
    managerCompany: yup
        .string()
        .oneOf(["vigo", "agency"], requiredMessage)
        .required(requiredMessage)
});
